import { notEmpty, parseJsonObject, parseNumber, parseRecord, parseString } from "@de-xima/xima-common-js-lang";
import $ from "jquery";

function receiveHeightChange(iframe: HTMLElement, origin: string) {
  window.addEventListener("message", (event) => {
    if (event.origin !== origin) {
      return;
    }
    const data = parseRecord(event.data);
    switch (data.type) {
      case "formcycle-height-change": {
        const payload = parseRecord(data.payload);
        const height = parseNumber(payload.height);
        iframe.style.height = `${parseString(height)}px`;
        break;
      }
    }
  });
}

/**
 * Sends a message to the iframe (when open) with the form to manage the current user contract.
 * @param contractDataJson Json object with the contract data of current logged in user
 */
export function loadContractUrlData(contractDataJson: string, url: string): void {
  const iframe = $(".contract-frame").get(0);
  if (iframe instanceof HTMLIFrameElement) {
    const origin = notEmpty(url) ? new URL(url).origin : "*";
    iframe.addEventListener("load", () => {
      const contractData = parseJsonObject(contractDataJson);
      iframe.contentWindow?.postMessage(
        {
          payload: contractData,
          type: "formcycle-contract-data",
        },
        origin,
      );
    });
    receiveHeightChange(iframe, origin);
    iframe.src = url;
  }
}
